import { ApiError } from '../services/smsApi';
import { RentalPurchaseOrder } from '../types/models';

export interface PurchaseRecoveryRecord {
  quoteId: string;
  operationKey: string;
  orderId: string | null;
  amount: number;
  createdAt: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function readPurchaseRecovery(key: string): PurchaseRecoveryRecord | null {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!isRecord(parsed)
      || typeof parsed.quoteId !== 'string'
      || typeof parsed.operationKey !== 'string'
      || (parsed.orderId !== null && typeof parsed.orderId !== 'string')
      || !Number.isFinite(Number(parsed.amount))
      || typeof parsed.createdAt !== 'string') return null;
    return {
      quoteId: parsed.quoteId,
      operationKey: parsed.operationKey,
      orderId: parsed.orderId,
      amount: Number(parsed.amount),
      createdAt: parsed.createdAt,
    };
  } catch {
    return null;
  }
}

export function savePurchaseRecovery(key: string, value: PurchaseRecoveryRecord | null): void {
  try {
    if (value) window.localStorage.setItem(key, JSON.stringify(value));
    else window.localStorage.removeItem(key);
  } catch {
    // Недоступный localStorage не должен блокировать покупку.
  }
}

export function getOrderFromApiError(error: unknown): RentalPurchaseOrder | null {
  if (!(error instanceof ApiError) || !isRecord(error.details)) return null;
  const data = error.details.data;
  if (!isRecord(data) || !isRecord(data.order) || typeof data.order.id !== 'string') return null;
  return data.order as unknown as RentalPurchaseOrder;
}

export function getCodeFromApiError(error: unknown): string | null {
  if (!(error instanceof ApiError) || !isRecord(error.details)) return null;
  return typeof error.details.code === 'string' ? error.details.code : null;
}
